export default __webpack_public_path__ + "static/media/hospitable.f22e4ffa.png";